import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ element, privilege, redirectTo = '/dashboard' }) => {
  const { isLoggedIn, privileges } = useSelector((store) => store.login);
  const location = useLocation();

  // Not logged in at all — send to login
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but missing the required privilege — send to fallback
  if (privilege && !privileges?.[privilege]) {
    return <Navigate to={redirectTo} replace />;
  }

  return element;
};

ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
  privilege: PropTypes.string,
  redirectTo: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  privilege: null,
  redirectTo: '/dashboard',
};

export default ProtectedRoute;
